import { doc } from 'firebase/firestore';
import { version } from 'package.json';
import { fallbackLocale, Locales } from 'shared/assets/localization';
import { setPushNotificationTokenDate } from 'shared/services/local-storage';
import { ID } from 'shared/types/id';
import { isProductionEnvironment } from 'shared/utils/is-environment';

import {
  CollectionOptions,
  getCollection,
  setDocWithTimestamp,
  setPushNotificationToken,
} from './helpers';

export const createPushToken = async (
  uid: ID,
  token: string,
  locale: Locales = fallbackLocale,
) => {
  if (!isProductionEnvironment) {
    // eslint-disable-next-line no-console -- dev only
    console.log('create push token - ', { token, uid });
  }
  if (!uid || !token) {
    return;
  }

  const newDoc = doc(getCollection(CollectionOptions.FcmTokens), token);
  const newDocData = {
    token,
    uid,
    type: 'desktop',
    platform: 'web', // todo: when electron is created, change this to electron
    version,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: locale,
  };

  setDocWithTimestamp(newDoc, newDocData);
  // Add to the local storage
  setPushNotificationToken(uid, token);
  setPushNotificationTokenDate(uid, new Date());
};
